import { render } from "./MenuLkBit.vue?vue&type=template&id=6eaa8430"
import script from "./MenuLkBit.vue?vue&type=script&lang=js"
export * from "./MenuLkBit.vue?vue&type=script&lang=js"

import "./MenuLkBit.vue?vue&type=style&index=0&id=6eaa8430&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__